<script lang="ts" setup name="OrganisationPortCallsDetailsRotation">
import { computed, ref } from 'vue';
import { useRouter } from 'vue-router';

import { usePortCallsMilestones } from '~/features/usePortCallsMilestones';
import { useService } from '~/features/useService';

import Service from '~/services/Service.js';

import Card from '~/components/Card.vue';
import ServiceCard from '~/components/ServiceCard.vue';
import VoyageTracker from '~/components/VoyageTracker.vue';

import type {
  IPortsCallsPort,
  IPortsCallsScheduleResponse,
  IVoyageTrackerStep,
} from '~/types';

const { organisationId, portId } = defineProps<{
  organisationId: OrganisationId;
  portId: string;
}>();

const milestones = ref<IPortsCallsPort[]>([]);

const router = useRouter();

const voyageTrackerMilestones = computed<IVoyageTrackerStep[]>(() =>
  usePortCallsMilestones({
    ports: milestones.value,
    organisationId,
    router,
    lastVoyagePortId: portId,
  }),
);

const serviceState = useService(
  Service.organisation(organisationId).portCallsCalls().portRotation(portId),
  ({ data }: { data: IPortsCallsScheduleResponse }) => {
    if (!data.ports.length) return false;
    milestones.value = data.ports;

    return true;
  },
);
</script>

<template>
  <ServiceCard v-bind="serviceState" styled>
    <Card title="Port Rotation">
      <VoyageTracker
        v-for="milestone in voyageTrackerMilestones"
        :key="milestone.id"
        :data-testid="milestone.id"
        v-bind="milestone"
      />
    </Card>
  </ServiceCard>
</template>
